import React from "react";
import { Text, View } from "react-native";
import tw from "twrnc";

import Button from "@/components/settings/Button";
import { colors, text } from "@/components/settings/theme";
import { t } from "@/localization";

// One of the account's data files (CSV): what's in it on the left, its
// download button on the right. Same layout as a recording row.
const DataFileRow = ({ item, state, onDownload, first }) => (
  <View
    testID={`file-${item.file}`}
    style={[
      tw`flex-row items-center py-3`,
      { borderBottomWidth: 1, borderBottomColor: colors.divider },
      first && { borderTopWidth: 1, borderTopColor: colors.divider },
    ]}
  >
    <View style={tw`flex-1 pr-3`}>
      <Text style={text.bodyStrong}>{item.title}</Text>
      <Text style={[text.hint, tw`mt-0.5`]}>{item.description}</Text>
    </View>
    <Button
      size="sm"
      fullWidth={false}
      text="CSV"
      icon="download-outline"
      accessibilityLabel={t("Download {title} (CSV)", { title: item.title })}
      loading={state?.status === "checking"}
      onPress={() => onDownload(item.file)}
    />
  </View>
);

export default React.memo(DataFileRow);
